// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3WGCQ","row":"Node_row__1J7MG","label":"Node_label__YuGxo","footer":"Node_footer__2fNSs"};